module.exports = __webpack_public_path__ + "img/20191226153740956.e5a6cc14.jpg";